/* eslint-disable */
import React from "react";
import RenderCalendlyLinks from "../../components/common/RenderCalendlyLinks";
import NewProductTemplate from "../../components/sections/product-more-info/Item";
import { cn } from "../../utils/cn";
import Emoji from "../../utils/emoji";
import ProductTemplate from "./product";

const Product = (props) => {
    const { pageContext } = props;
    const { item } = pageContext;

    const newProductsEnabled =
        process.env.GATSBY_NEW_PRODUCTS_ENABLED === "true";

    const Data = () => {
        return (
            <section className="mx-auto max-w-xl text-left font-inter text-gray-500 lg:max-w-2xl xl:max-w-3xl">
                <h2 className={cn(styles.title)}>
                    <Emoji symbol="🎤" label="entrevista premium" /> FASE 4:
                    Simulacre d’Entrevista Premium Mossos d&apos;Esquadra
                </h2>

                <p className="mt-5">
                    El{" "}
                    <strong className="text-cpurple">
                        Simulacre d’Entrevista Premium (Fase 4)
                    </strong>{" "}
                    és la preparació{" "}
                    <strong className="text-cpurple">
                        més completa i exigent
                    </strong>{" "}
                    per afrontar l’entrevista policial de Mossos d’Esquadra.
                </p>

                <p>
                    Una{" "}
                    <strong className="text-cpurple">
                        sessió individual, presencial i d’alt nivell
                    </strong>
                    , dissenyada per simular amb la màxima fidelitat el context
                    real de l’entrevista oficial.
                </p>

                <p>
                    Des del primer minut{" "}
                    <strong className="text-cpurple">
                        seràs avaluat com el dia de la prova
                    </strong>
                    , amb{" "}
                    <strong className="text-cpurple">
                        dos professionals especialitzats
                    </strong>
                    .
                </p>

                <h2 className={cn(styles.title, "mt-10")}>
                    <Emoji symbol="🎯" label="objectiu" /> Què és el Simulacre
                    Premium?
                </h2>

                <p className="mt-5">
                    És una{" "}
                    <strong className="text-cpurple">
                        simulació oficial d’entrevista policial
                    </strong>{" "}
                    de Mossos d’Esquadra, basada íntegrament en{" "}
                    <strong className="text-cpurple">
                        el model real de la convocatòria
                    </strong>
                    , amb una{" "}
                    <strong className="text-cpurple">
                        doble avaluació professional
                    </strong>
                    .
                </p>

                <p>Durant la sessió:</p>

                <ul className={cn(styles.list, "mt-5")}>
                    <li>
                        <strong className="text-cpurple">
                            realitzes una entrevista completa en condicions
                            reals
                        </strong>
                        .
                    </li>
                    <li>
                        <strong className="text-cpurple">
                            se t’avalua per competències
                        </strong>
                        .
                    </li>
                    <li>
                        <strong className="text-cpurple">
                            reps un feedback exhaustiu i objectiu
                        </strong>
                        .
                    </li>
                </ul>

                <p className="mt-5">
                    Aquesta fase està pensada per opositors que{" "}
                    <strong className="text-cpurple">
                        volen el màxim nivell d’exigència
                    </strong>{" "}
                    abans del dia clau.
                </p>

                <h2 className={cn(styles.title, "mt-10")}>
                    <Emoji symbol="🧠" label="metodologia" /> Com es desenvolupa
                    la Fase 4?
                </h2>

                <ul className={cn(styles.list, "mt-5")}>
                    <li>
                        <strong className="text-cpurple">Durada:</strong> 1 hora
                    </li>
                    <li>
                        <strong className="text-cpurple">Format:</strong>{" "}
                        presencial i individual
                    </li>
                    <li>
                        <strong className="text-cpurple">Avaluadors:</strong>
                        <ul className="ml-5 mt-2 list-disc">
                            <li>
                                1 psicòleg especialitzat en selecció policial
                            </li>
                            <li>
                                1 caporal de Mossos d’Esquadra, expert en
                                processos de selecció
                            </li>
                        </ul>
                    </li>
                </ul>

                <p className="mt-5">La sessió inclou:</p>

                <ul className={cn(styles.list, "mt-5")}>
                    <li>
                        <strong className="text-cpurple">
                            Simulacre d’entrevista basat en l’oficial
                        </strong>
                        .
                    </li>
                    <li>
                        <strong className="text-cpurple">
                            Preguntes alineades amb les competències exigides
                        </strong>{" "}
                        a la convocatòria.
                    </li>
                    <li>
                        <strong className="text-cpurple">
                            Avaluació mitjançant graella oficial
                        </strong>{" "}
                        amb puntuació per competència.
                    </li>
                    <li>
                        <strong className="text-cpurple">
                            Doble avaluació (psicòleg + caporal)
                        </strong>
                        .
                    </li>
                    <li>
                        <strong className="text-cpurple">
                            Anàlisi detallada de:
                        </strong>
                        <ul className="ml-5 mt-2 list-disc">
                            <li>comunicació verbal i no verbal,</li>
                            <li>coherència del discurs,</li>
                            <li>gestió de la pressió,</li>
                            <li>adequació al perfil professional de Mossos.</li>
                        </ul>
                    </li>
                    <li>
                        <strong className="text-cpurple">
                            Feedback final complet
                        </strong>{" "}
                        amb punts forts, àrees de millora i recomanacions
                        clares.
                    </li>
                </ul>

                <h2 className={cn(styles.title, "mt-10")}>
                    <Emoji symbol="👤" label="perfil" /> A qui va dirigit?
                </h2>

                <p className="mt-5">Aquest simulacre és ideal si:</p>

                <ul className={cn(styles.list, "mt-5")}>
                    <li>
                        Et presentes a l’entrevista policial de Mossos
                        d’Esquadra.
                    </li>
                    <li>
                        <strong className="text-cpurple">
                            Vols una valoració objectiva i professional
                        </strong>{" "}
                        del teu rendiment.
                    </li>
                    <li>
                        <strong className="text-cpurple">
                            Vols corregir errors abans que siguin determinants
                        </strong>
                        .
                    </li>
                    <li>
                        Busques una{" "}
                        <strong className="text-cpurple">
                            preparació premium i d’alt impacte
                        </strong>
                        .
                    </li>
                </ul>

                <p className="mt-5">
                    <strong className="text-cpurple">
                        Especialment recomanat com a últim pas
                    </strong>{" "}
                    abans de l’entrevista oficial.
                </p>

                <h2 className={cn(styles.title, "mt-10")}>
                    <Emoji symbol="🔥" label="resum" /> En resum
                </h2>

                <p className="mt-5">
                    El{" "}
                    <strong className="text-cpurple">
                        Simulacre d’Entrevista Premium Mossos (Fase 4)
                    </strong>{" "}
                    és la preparació{" "}
                    <strong className="text-cpurple">
                        més completa i exigent
                    </strong>{" "}
                    per afrontar l’entrevista amb garanties reals d’èxit.
                </p>

                <h2 className={cn(styles.title, "mt-10")} id="reserva">
                    <Emoji symbol="📅" label="reserva" /> Reserva la teva hora!
                </h2>

                <p className="mt-5">
                    Disposem de{" "}
                    <strong className="text-cpurple">
                        professionals especialitzats en selecció policial
                    </strong>
                    : psicòlegs experts en entrevistes i{" "}
                    <strong className="text-cpurple">
                        comandaments de Mossos d’Esquadra
                    </strong>{" "}
                    amb experiència real en processos d’avaluació.
                </p>

                <p className="mt-5">
                    A continuació pots consultar els{" "}
                    <strong className="text-cpurple">
                        calendaris disponibles
                    </strong>{" "}
                    i reservar l’hora amb el psicòleg i el comandament.
                </p>

                <p className="mt-5">
                    👉{" "}
                    <strong className="text-cpurple">
                        Si vols saber com rendiries davant el tribunal real,
                        aquest és el teu simulacre
                    </strong>
                    .
                </p>

                <RenderCalendlyLinks
                    stock={item.stock}
                    calendly_schedule={item.calendly_schedule}
                />
            </section>
        );
    };

    return (
        <>
            {!newProductsEnabled ? (
                <ProductTemplate item={item}>
                    <Data />
                </ProductTemplate>
            ) : (
                <NewProductTemplate
                    item={item}
                    title="Sessió personalitzada per defensar el teu perfil amb seguretat i criteri a l'entrevista de Mossos d'Esquadra."
                >
                    <Data />
                </NewProductTemplate>
            )}
        </>
    );
};

const styles = {
    strong: "font-semibold text-ccyan",
    title: "font-bold text-xl font-montserrat",
    list: "list-disc ml-4",
};

export default Product;
